/**
 * Check if the current browser is Safari.
 * Note that this might not be perfect and could evolve in the future. This can
 * only be used to show warnings specific to Safari.
 * @returns true if the browser is Safari, othwerwise false.
 */
export function isSafari() {
    // We check `vendor` on purpose even though it is deprecated. It is just an additional
    // assurance in case the information is available
    return (!navigator.vendor || navigator.vendor.indexOf('Apple') !== -1) &&
        /safari/i.exec(navigator.userAgent) &&
        !/CriOS|FxiOS|android|chrome|EdgiOS/i.exec(navigator.userAgent);
}

export function isIOS() {
    // We check `platform` on purpose even though it is deprecated. It is just an additional
    // assurance in case the information is available
    return (navigator.platform && /iP(hone|od|ad)/i.test(navigator.platform)) ||
            /(iPhone|iPod|iPad)/i.test(navigator.userAgent);
}

export function canSetPartitionedCookies() {
    let result = false;
    document.cookie = '__Host-testCookie=a; Secure; SameSite=None; Path=/; Partitioned';
    if (document.cookie?.includes('__Host-testCookie')) {
        result = true;
        document.cookie = '__Host-testCookie=; Max-Age=0';
    }
    return result;
}
